import { render } from "./TopPageHeaderOrganism.vue?vue&type=template&id=8930ffd2&scoped=true"
const script = {}

import "./TopPageHeaderOrganism.vue?vue&type=style&index=0&id=8930ffd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8930ffd2"]])

export default __exports__